













import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import { authenticationService } from '@/services';

@Component({ components: { mdbBtn, mdbIcon } })
export default class Error403ForbiddenView extends Vue {
    private isCurrentUserAuthenticated: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.errors.error403ForbiddenView.pageName');
        this.isCurrentUserAuthenticated = await authenticationService.isAuthenticated;
    }

    private async login(): Promise<void> {
        await authenticationService.logout('/dashboard');
    }
}
